import { render } from "./about_page.vue?vue&type=template&id=29857ca9&scoped=true"
import script from "./about_page.vue?vue&type=script&lang=js"
export * from "./about_page.vue?vue&type=script&lang=js"

import "./about_page.vue?vue&type=style&index=0&id=29857ca9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29857ca9"]])

export default __exports__